export function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Encryption',
      description: 'Military-grade 256-bit AES encryption protects your data from hackers, ISPs, and government surveillance, ensuring complete privacy for all your online activities.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Anonymous Browsing',
      description: 'Hide your IP address and browse the internet anonymously. Our VPN masks your real location and prevents websites from tracking your online behavior and personal information.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our worldwide server network. Connect to servers across multiple countries for unrestricted access to global content and services.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast connection speeds with unlimited bandwidth. Our optimized servers ensure smooth streaming, gaming, and browsing without any slowdowns or interruptions.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Our VPN works seamlessly on desktop, mobile, tablets, and more, providing comprehensive security across all platforms.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Get help whenever you need it with our dedicated support team. We provide round-the-clock assistance to ensure your VPN experience is smooth and hassle-free.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line text-teal-600"></i>
            <span className="text-teal-900 text-sm font-semibold">Premium Features</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our VPN
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the ultimate in online security and privacy with our comprehensive VPN solution designed for modern internet users
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
